import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { AppState } from '../../../store/model';
import { findSegment as findSegmentOptions } from '../../../store/reducers/segment-options/selectors';
import { OptionDesktop } from './Option/OptionDesktop';
import { isSaviSelectIntl } from '../../../store/reducers/itinerary/selectors';
import { getLandIdsWithinSegmentForSaviSelectIntl } from '../../../store/reducers/itinerary/saviSelectIntlSelector';
import {
  createStyles,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import messages from '../../../intl/messages';
import { FormattedMessage } from 'react-intl';

interface OwnProps {
  segmentId: number;
  showDisclaimer: boolean;
}

interface StateProps {
  ids: string[];
}

interface OptionsDesktopProps
  extends OwnProps,
    StateProps,
    WithStyles<typeof styles> {}

class OptionsDesktopBase extends PureComponent<OptionsDesktopProps> {
  public render() {
    const { ids, segmentId, showDisclaimer, classes } = this.props;

    return (
      <>
        {ids.map((id, index) => (
          <OptionDesktop
            key={id}
            index={index}
            isRecommended={index === 0}
            optionId={id}
            segmentId={segmentId}
          />
        ))}

        {showDisclaimer && (
          <Typography variant="caption" className={classes.marginTop}>
            <FormattedMessage {...messages.hotel.disclaimer} />
          </Typography>
        )}
      </>
    );
  }
}

const mapStateToProps = (
  state: AppState,
  { segmentId }: OptionsDesktopProps,
): StateProps => {
  return {
    ids: !isSaviSelectIntl(state)
      ? findSegmentOptions(segmentId)(state).optionIds
      : getLandIdsWithinSegmentForSaviSelectIntl(segmentId)(state),
  };
};

const styles = (theme: Theme) =>
  createStyles({
    marginTop: {
      marginTop: theme.spacing.unit * 2,
    },
  });

const enhance = compose<OptionsDesktopProps, OwnProps>(
  pure,
  connect(mapStateToProps),
  withStyles(styles),
);

/**
 * Segment options (for desktop screens)
 *
 * Note: not used on Mobile - on mobile, the equivalent is handled by the ContentMobile component
 */
export const OptionsDesktop = enhance(OptionsDesktopBase);

OptionsDesktop.displayName = 'OptionsDesktop';
